import defaultAttributes from '../defaultAttributes';

const Clock11 = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['polyline', { points: '12 6 12 12 9.5 8' }],
  ],
];

export default Clock11;
